export class ProductQueryParameters {
  id?: string;
  isBeta?: boolean;
  isInternalApp?: boolean;
  name?: string;

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
